export default "__VITE_ASSET__CuVu6kzJ__"